import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import ListHeader from "components/PantallaList/Header/ListHeader";
import ReporteViewer from "components/Reportes/ReporteViewer";
import useExceptionHandler from "hooks/useExceptionHandler";
import { Reporte606Manager } from "managers";

function Reporte606({ showLoading, hideLoading }) {
  const { handleException } = useExceptionHandler();
  const [reporte, setReporte] = useState({});
  const [showCanvas, setShowCanvas] = useState(false);

  const imprimirPDF = () => {
    showLoading();
    Reporte606Manager.imprimirPDF()
      .then((data) => {
        setReporte(data);
        setShowCanvas(true);
      })
      .catch((error) => handleException(error))
      .finally(() => hideLoading());
  };

  const descargar = (promesa, nombreArchivo) => {
    showLoading();
    const link = document.createElement("a");
    link.target = "_blank";
    link.download = nombreArchivo;
    promesa
      .then((blob) => {
        link.href = URL.createObjectURL(blob);
        link.click();
      })
      .catch((error) => handleException(error))
      .finally(() => hideLoading());
  };

  return (
    <div>
      <ListHeader titulo="Reporte 606" />
      <Card style={{ margin: "1em" }}>
        <Card.Body>
          <Card.Title>Descargar Reporte 606</Card.Title>
          <Card.Text className="text-muted" style={{ marginBottom: "1.5em" }}>
            Selecciona el formato en que deseas generar el Reporte 606 (DGII).
          </Card.Text>
          <div className="d-flex" style={{ gap: "1em" }}>
            <AnimatedIconButton
              iconName="print"
              message="Imprimir PDF"
              size="38px"
              height="20px"
              width="20px"
              onClick={imprimirPDF}
            />
            <AnimatedIconButton
              iconName="export"
              message="Descargar Excel"
              size="38px"
              height="20px"
              width="20px"
              onClick={() =>
                descargar(Reporte606Manager.descargarExcel(), "Reporte606.xls")
              }
            />
            <AnimatedIconButton
              iconName="download"
              message="Descargar CSV"
              size="38px"
              height="20px"
              width="20px"
              onClick={() =>
                descargar(Reporte606Manager.descargarCSV(), "Reporte606.csv")
              }
            />
          </div>
        </Card.Body>
      </Card>
      <ReporteViewer
        reporte={reporte}
        showCanvas={showCanvas}
        setShowCanvas={setShowCanvas}
      />
    </div>
  );
}

export default Reporte606;
